import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "orderDetailProduct"
  }, [_c("div", {
    staticClass: "modular"
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.productTitle")))]), _c("div", {
    staticClass: "productList"
  }, [[_c("div", {
    staticClass: "orderChannel"
  }, [_c("div", {
    staticStyle: {
      flex: "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailProduct.orderNo")) + "：" + _vm._s(_vm.productInfo.orderNo) + " "), _c("a-tag", {
    staticClass: "orderStatus",
    attrs: {
      color: "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.productInfo.orderStatus == 1 ? _vm.$t("public.orderStatus2") : _vm.productInfo.orderStatus == 2 ? _vm.$t("public.orderStatus99") : _vm.$t("public.orderStatus7")) + " "), _vm.orderStatusList.length > 0 ? _c("div", {
    staticClass: "orderStatusList"
  }, [_c("a-steps", {
    attrs: {
      "progress-dot": "",
      direction: "vertical"
    }
  }, _vm._l(_vm.orderStatusList, function (Status, key) {
    return _c("a-step", {
      key: key,
      attrs: {
        title: _vm.getStatus(Status),
        status: "finish"
      }
    });
  }), 1)], 1) : _vm._e()])], 1), _c("div", {
    staticStyle: {
      flex: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailProduct.arriveDate")) + "：" + _vm._s(_vm.productInfo.arriveDate) + " " + _vm._s(_vm.productInfo.arriveTimeStr || "")), _c("br")])]), [_c("a-table", {
    key: "transport",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      pagination: false,
      bordered: "",
      rowKey: "id",
      columns: _vm.columns,
      "data-source": _vm.productInfo.productList
    },
    scopedSlots: _vm._u([{
      key: "productName",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productType == 0 ? _c("router-link", {
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.productId
              }
            }
          }
        }, [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]) : _c("span", [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]), record.activityList && record.activityList.length > 0 ? [[_c("a-tooltip", [_c("a-tag", {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("orderDetailProduct.takepartinActivity")))]), _vm._l(record.activityList, function (activityItem, index) {
          return _c("template", {
            slot: "title"
          }, [_c("div", {
            key: index
          }, [_vm._v(_vm._s(activityItem.activityName))])]);
        })], 2)]] : _vm._e(), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.transportName")) + "：" + _vm._s((record.transportName ? record.transportName : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.chineseName")) + "：" + _vm._s((record.traditionalProductName ? record.traditionalProductName : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.rongliang")) + "：" + _vm._s((record.capacity ? record.capacity : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.rushu")) + "：" + _vm._s((record.caseQuantity ? record.caseQuantity : "--") + "   "))]), _c("span", [_vm._v(_vm._s("JAN") + "：" + _vm._s((record.janCode ? record.janCode : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.brand")) + "：" + _vm._s((record.productBrand ? record.productBrand : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.source")) + "：" + _vm._s((record.productSourcearea ? record.productSourcearea : "--") + "   "))])], 2);
      }
    }, {
      key: "caseOrItem",
      fn: function fn(text, record) {
        return _c("span", {}, [record.caseOrItem ? _c("span", [_vm._v(_vm._s(record.caseOrItem == 1 ? _vm.$t("orderDetail2.totalBox") : _vm.$t("orderDetail2.sanBox")))]) : _c("span", [_vm._v("--")])]);
      }
    }])
  })]]], 2)]), _c("a-modal", {
    attrs: {
      title: _vm.agentTitle,
      visible: _vm.agentVisible,
      footer: null,
      rowKey: "expressNo"
    },
    on: {
      cancel: function cancel() {
        return _vm.agentVisible = false;
      }
    }
  }, [_c("a-table", {
    attrs: {
      footer: null,
      pagination: false,
      columns: _vm.columnsAgent,
      "data-source": _vm.agentData
    },
    scopedSlots: _vm._u([{
      key: "expressNo",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.handleClick(record);
            }
          }
        }, [_vm._v(_vm._s(record.name))])]);
      }
    }, {
      key: "expressNoAmount",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.formatMoney(record.expressNoAmount)) + " ")]);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };